module.exports = __webpack_public_path__ + "img/product-preview-35.a80dbb5.png";